module.exports = __webpack_public_path__ + "static/media/stijnbessem-case-voxi-intro-card1.2@2x.a7a47cb7.jpg";